import "aos/dist/aos.css";
import React from "react";
import styled from "styled-components";
import IconIntro01 from "../../assets/images/icon-intro-01.jpg";
import IconIntro02 from "../../assets/images/icon-intro-02.png";
import IconIntro03 from "../../assets/images/icon-intro-03.png";
import GridItem from "./Layout/GridItem";
import InnerSection from "./Layout/InnerSection";
import Section from "./Layout/Section";
import ThreeColumnGrid from "./Layout/ThreeColumnGrid";
import SubTitle from "./Text/SubTitle";
import TextBlock from "./Text/TextBlock";
function IntroductionContainer({ type, children }) {
  return (
    <Section padding="100px 0" background="#FAFAFA" id="page2">
      <InnerSection>
        <SubTitle
          fontSize="40"
          fontWeight="300"
          data-aos="fade-up"
          data-offset="120"
        >
          <strong>모시러 채용/파견</strong>은 퀄리티 높은 수행기사를 <br />
          안정적으로 이용할 수 있는 서비스입니다.
        </SubTitle>
        <ColumnGrid>
          <GridItem data-aos="fade-up" data-aos-delay="100">
            <PhilosophyImage src={IconIntro01} alt="icon" />
            <ItemTitle textAlign="center">드라이버 검증</ItemTitle>
            <TextBlock fontSize="16" textAlign="center">
              운전 뿐만 아니라 서비스 에티튜드, <br />범죄/사고이력 검증으로 엄선합니다.

            </TextBlock>
          </GridItem>
          <GridItem data-aos="fade-up" data-aos-delay="150">
            <PhilosophyImage src={IconIntro02} alt="icon" />
            <ItemTitle textAlign="center">
              자체 관리 시스템
            </ItemTitle>
            <TextBlock fontSize="16" textAlign="center">
              근태 관리 뿐만 아니라 차량 관리/이용 내역을 <br />
              자체 ERP를 통해 확인 가능합니다.
            </TextBlock>
          </GridItem>
          <GridItem data-aos="fade-up" data-aos-delay="200">
            <PhilosophyImage src={IconIntro03} alt="icon" />
            <ItemTitle textAlign="center">보증기간 1년</ItemTitle>
            <TextBlock fontSize="16" textAlign="center">
              분기별 정기 서비스 교육을 통해<br />
              드라이버의 퀄리티를 유지합니다.
            </TextBlock>
          </GridItem>
        </ColumnGrid>
      </InnerSection>
    </Section>
  );
}
const PhilosophyImage = styled.img`
  width: 378px;
  max-width: 100%;
  @media (max-width: 640px) {
    width: 100%;
    margin-bottom: 16px;
  }
`;
const IntroductionIcon = styled.img`
  display: block;
  width: 348px;
  max-width: 100%;
  margin: 0 auto 42px;
  @media (max-width: 640px) {
    width: 150px;
    margin: 0 auto 24px;
  }
`;
const ColumnGrid = styled(ThreeColumnGrid)`
  margin-top: 82px;
  @media (max-width: 640px) {
    margin-top: 60px;
  }
`;
const ItemTitle = styled(TextBlock).attrs({
  fontWeight: `bold`,
  fontSize: `24`,
})`
  margin-bottom: 12px;
`;
export default IntroductionContainer;
